// appts_analysis.js
import React from "react";

const ApptsAnalysis = ({ userData }) => {
  return (
    <div style={{ padding: 20 }}>
      <h3>Appointments analysis</h3>
      <p>Component loaded. Hook up your analysis UI here.</p>
      {userData && (
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {/* remove this pre block later if not needed */}
          {JSON.stringify(userData, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default ApptsAnalysis;
